<template>
  <div class="content_box mt-4">
    <v-tabs
      v-model="tab"
      background-color="white"
      slider-color="rgb(21, 142, 141)"
      active-class="tab-active"
    >
      <v-tab
        v-for="(tabButton, index) in tabsButtons"
        :key="index"
        class="tab-padding"
        :href="tabButton.href"
        @click="changeTab(tabButton)"
      >
        {{ tabButton.title }}
      </v-tab>
    </v-tabs>
    <v-row>
      <v-col cols="12">
        <v-sheet height="64">
          <v-toolbar
            flat
            class="text-center"
          >
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>

            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              {{ local.calendar.today }}
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="800">
          <v-calendar
            ref="calendar"
            v-model="focus"
            :locale="'AR'"
            color="primary"
            :interval-height="125"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            :show-month-on-first="false"
            :event-overlap-mode="'stack'"
            :weekdays="weekdays"
            :first-interval="firstHour"
            :interval-minutes="60"
            :interval-count="totalHours"
            :event-more-text="local.calendar.more"
            :class="type=='day'||type=='week'?'calendar-day':''"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          >
            <template
              v-if="type=='month'"
              v-slot:event="{ event }"
            >
              <div class="event">
                <session-summary
                  :session="event.details"
                  :case-object-key="event.details.caseObjectKey"
                  :is-pega="event.details.isPega"
                  :court-id="event.details.courtId"
                ></session-summary>
              </div>
            </template>

            <template v-slot:interval="{date , time }">
              <div
                v-if="type=='week'"
                class="week"
              >
                <div
                  v-for="(event, index) in getEvents(date,time)"
                  :key="index"
                  class="pa-1 ma-1 event"
                >
                  <session-summary
                    :session="event.details"
                    :case-object-key="event.details.caseObjectKey"
                    :is-pega="event.details.isPega"
                    :court-id="event.details.courtId"
                  ></session-summary>
                </div>
              </div>
              <v-row v-if="type=='day'">
                <v-col
                  v-for="(event, index) in getEvents(date,time)"
                  :key="index"
                  cols="4"
                  class="pt-0"
                >
                  <calendar-session-card
                    :session="event.details"
                    :case-object-key="event.details.caseObjectKey"
                    :is-pega="event.details.isPega"
                    :court-id="event.details.courtId"
                  ></calendar-session-card>
                </v-col>
              </v-row>
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { getDateObj } from '@/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapLawsuitActions } = createNamespacedHelpers('LawsuitModule');
import SessionSummary from '../components/cards/session-summary.vue';
import CalendarSessionCard from '../components/cards/calendar-session-card.vue';

export default {
  components: {
    SessionSummary,
    CalendarSessionCard,
  },
  data() {
    return {
      tab: null,
      scrollPush: 0,
      loading: false,
      focus: '',
      type: 'day',
      typeToLabel: {
        month: this.local.calendar.month,
        week: this.local.calendar.week,
        day: this.local.calendar.day,
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      firstHour: 7,
      totalHours: 13,
      weekdays: [6, 0, 1, 2, 3, 4],
      tabsButtons: [
        {
          href: '#tab-3',
          title: this.local.calendar.day,
          name: 'day',
        },
        {
          href: '#tab-2',
          title: this.local.calendar.week,
          name: 'week',
        },
        {
          href: '#tab-1',
          title: this.local.calendar.month,
          name: 'month',
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    getDateObj,
    async copyURL() {
      await navigator.clipboard.writeText(this.session.videoConferenceUrl);
      this.toaster.success(this.local.home.upcomingSessions.copied);
    },
    ...mapLawsuitActions(['getSessionsRange']),
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
      this.tab = 'tab-3';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = '';
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getEvents(date, time) {
      var dates = getDateObj(date, time);
      return this.events.filter(event => event.start >= dates.start && event.end < dates.end);
    },
    updateRange({ start, end }) {
      // to get the all displayed days on the view
      // as start and end contains only current selected month
      // in case of start.date == end.date this means it will show only one day
      const viewStart = (start.date != end.date) ? this.$refs.calendar.getStartOfWeek(start) : start;
      const viewEnd = (start.date != end.date) ? this.$refs.calendar.getEndOfWeek(end) : end;
      this.getSessionsRange({
        dateFrom: viewStart.date,
        dateTo: viewEnd.date,
      }).then(({ data }) => {
        this.events = data
          .map((event) => {
            return {
              name: event.sessionType,
              start: new Date(event.appointmentStartDate),
              end: new Date(event.appointmentEndDate),
              timed: true,
              details: event,
            };
          });

      }).catch(() => { })
        .finally(() => {
          this.loading = false;
        });

    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    changeTab(tab) {
      this.type = tab.name;
      this.tab = tab.href;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-padding {
  font-size: 24px;
  padding-bottom: 20px;
  color: var(--app-dark-primary-color) !important;
  .v-chip {
    cursor: pointer;
    color: #ffffff;
    background: #67868b !important;
    border-radius: 0px !important;
  }
}
    .tab-active {
        color: var(--app-primary-color) !important;
        font-weight: bold;

        .v-chip {
            background: var(--app-lighter-primary-color) !important;
        }
    }

::v-deep .v-tabs {
  .v-tabs-bar {
    border-bottom: 1px solid #e8e8e8 !important;
    .v-tabs-slider-wrapper {
      height: 5px !important;
    }
  }
}

::v-deep .v-event {
  div {
    padding-right: 2px;
  }
  height: unset !important;
}
::v-deep .v-event-timed {
  height: unset !important;
}

::v-deep .v-calendar .v-event {
  margin-right: 4px;
}

::v-deep .v-calendar-daily__head {
  margin-right: 0px !important;
}

::v-deep .v-calendar-daily__interval {
  text-align: right;
}
::v-deep .v-calendar-weekly__day-label {
  text-align: right;
  .v-btn {
    font-weight: bold;
    font-size: 16px;
  }
}

::v-deep .theme--light.v-calendar-daily .v-calendar-daily__day-interval {
  border-top: #e0e0e0 2px solid;
}
::v-deep .v-calendar-daily__day-interval {
  display: flex;
  .session-card {
    padding: 0px !important;
  }
}
.event {
  color: var(--app-dark-primary-color) !important;
  border: 1px solid #e4e5e6;
}

::v-deep .v-calendar-daily__day-interval > .row {
  flex-wrap: nowrap;
  overflow-x: auto;
}

::v-deep .v-calendar-daily__day-interval > .row > .col-3 {
  display: inline-block;
  float: none;
}

::v-deep .calendar-day {
  .v-calendar-daily__body {
    .v-calendar-daily__scroll-area {
      .v-calendar-daily__pane {
        .v-calendar-daily__day-container {
          .v-calendar-daily__day {
            .v-event-timed-container {
              display: none;
            }
          }
        }
      }
    }
  }
}
::v-deep .v-calendar .v-event-more {
  z-index: 0;
}

::v-deep .v-calendar-daily__head .v-calendar-daily_head-day:last-child {
  padding-right: 17px;
}
.week {
  max-height: 125px;
  flex-wrap: nowrap;
  overflow-x: auto;
}
</style>
